import { combineReducers } from 'redux';

import counterReducer, { type CounterState } from '~/store/features/counter';
import toastReducer, { type ToastState } from '~/store/features/toast';

interface RootState {
    counter: CounterState;
    toast: ToastState;
}

// Import your reducers here when you create them
const rootReducer = combineReducers({
    counter: counterReducer,
    toast: toastReducer,
});

export type AppState = RootState;
export default rootReducer;